import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const POST_CREATE_DOMAIN = 'POST_CREATE_DOMAIN'
export const createDomainApi = apiCall(
  POST_CREATE_DOMAIN,
  ({ siteId, ...payload }: { siteId: string } & Record<string, unknown>) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/domains`),
    method: 'POST',
    body: payload,
    headers: appApiHeaders(),
  }),
)

const POST_UPDATE_DOMAIN = 'POST_UPDATE_DOMAIN'
export const updateDomainApi = apiCall(
  POST_UPDATE_DOMAIN,
  ({
    domainId,
    siteId,
    ...payload
  }: { domainId: string; siteId: string } & Record<string, unknown>) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/domains/${domainId}`),
    method: 'PATCH',
    body: payload,
    headers: appApiHeaders(),
  }),
)

const POST_DELETE_DOMAIN = 'POST_DELETE_DOMAIN'
export const deleteDomainApi = apiCall(
  POST_DELETE_DOMAIN,
  ({ domainId, siteId }: { domainId: string; siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/domains/${domainId}`),
    method: 'DELETE',
    headers: appApiHeaders(),
  }),
)

const POST_VERIFY_DOMAIN = 'POST_VERIFY_DOMAIN'
export const verifyDomainApi = apiCall(
  POST_VERIFY_DOMAIN,
  ({ domainId, siteId }: { domainId: string; siteId: string }) => ({
    endpoint: getApiUrl(
      `/api/cms/v1/sites/${siteId}/domains/${domainId}/verify`,
    ),
    method: 'POST',
    headers: appApiHeaders(),
  }),
)

const PATCH_SET_PRIMARY_DOMAIN = 'PATCH_SET_PRIMARY_DOMAIN'
export const setPrimaryDomainApi = apiCall(
  PATCH_SET_PRIMARY_DOMAIN,
  ({ domainId, siteId }: { domainId: string; siteId: string }) => ({
    endpoint: getApiUrl(
      `/api/cms/v1/sites/${siteId}/domains/${domainId}/primary`,
    ),
    method: 'POST',
    headers: appApiHeaders(),
  }),
)

const POST_RESET_PRIMARY_DOMAIN = 'POST_RESET_PRIMARY_DOMAIN'
export const resetPrimaryDomainApi = apiCall(
  POST_RESET_PRIMARY_DOMAIN,
  ({ siteId }: { siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/domains/primary/reset`),
    method: 'POST',
    headers: appApiHeaders(),
  }),
)
